import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CheckIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M12.9801 3.64649C13.1754 3.45139 13.492 3.45128 13.6872 3.64649C13.8822 3.84171 13.8822 4.1583 13.6872 4.35352L6.35319 11.6865C6.15793 11.8818 5.84142 11.8818 5.64616 11.6865L2.31315 8.35352C2.11789 8.15826 2.11789 7.84175 2.31315 7.64649C2.50841 7.45123 2.82492 7.45123 3.02018 7.64649L5.99967 10.626L12.9801 3.64649Z"
      fill="currentColor"
    />
  </svg>
);
